
import { Component, AfterContentInit, OnDestroy, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { FieldConfig } from '../../api/contract-notice-dto';
import { PaginationDTO } from '../../api/PaginationModel';
import { ExportProcessDTO } from '../../api/plyca-dtos-v2';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { Configuration } from '../../conf/app.constants';
import { PropertyService } from '../../properties/property.service';
import { ServiceLocator } from '../../ServiceLocator';
import { UIService } from '../../ui.service';
import { UserService } from '../../user.service';
import { exportProcessEditionPanelComponent } from './exportProcessEditionPanel.component';
import { BaseComponent } from '../../components/common/baseComponent/base.component';


@Component({
  selector: 'exportProcessPanel',
  templateUrl: 'exportProcessPanel.template.html',
  providers: [DialogService, UIService]

})
export class exportProcessPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;
  exportProcesses: ExportProcessDTO[] = [];
  filters: any = {};
  FROM_PARAM = 'from';
  TO_PARAM = 'to';
  USER_PARAM = 'user';
  waitService: WaitLoadingService;
  confirmationService: ConfirmationService;
  canModify: boolean;
  propertyService: PropertyService;
  private plycaErrorHandler: PlycaErrorHandler;

  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    public uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    private userService: UserService,
    public configuration: Configuration,
    public translate: TranslateService,
    public dialogService: DialogService
  ) {
    super();
    this.waitService = ServiceLocator.injector.get(WaitLoadingService);
    this.confirmationService = ServiceLocator.injector.get(ConfirmationService);
    this.propertyService = ServiceLocator.injector.get(PropertyService);
    this.plycaErrorHandler = ServiceLocator.injector.get(PlycaErrorHandler);
    this.waitService.startWaiting();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.EXPORTPROCESS));

    this.subscribe(this.propertyService.getProperty('MODIFICAR_EXPORTACIONES', '0').pipe(
      finalize(() => {

      }))
      , (value: string) => {
        this.canModify = value === '1'

      },
      (error) => {

      });
    this.initFilters();
    this.loadExportProcesses();
  }

  initFilters() {
    this.filters[this.USER_PARAM] = this.userService.getUser();
    let fromDate = new Date();
    fromDate.setMonth(fromDate.getMonth() - 1);
    this.filters[this.FROM_PARAM] = fromDate;
  }

  ngAfterContentInit(): void {
    this.headerActionsService.setTaskDescription(this.elem, 'ExportProcesses.title', 'fa fa-cloud-download', this.isLoaded.bind(this));
    this.subscribe(this.headerActionsService.addAction(
      'General.reload',
      'fas fa-sync-alt',
      'btn-secondary',
      true
    ), (success => {
      this.loadExportProcesses()
    }));


    this.headerActionsService.addDivider();

    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), (success => {
      this.uiService.routeBack();
    }));

  }

  ngOnDestroy(): void {
    this.uiService = null;

    this.dialogService = null;
    this.headerActionsService.clearActions();
    super.ngOnDestroy();

  }

  public isLoaded(): boolean {
    return this.loaded;
  }


  loadExportProcesses() {
    this.loaded = false;
    console.log('FILTROS');
    console.log(this.filters);
    /*

 this.plycaService.getExportProcesses(null)
    .
    */
    let params = {};
    if (this.filters[this.USER_PARAM] && this.filters[this.USER_PARAM].identifier) {
      params['ownerUserIdentifier'] = this.filters[this.USER_PARAM].identifier;
    }
    if (this.filters[this.TO_PARAM]) {
      params['creationDateTo'] = this.filters[this.TO_PARAM].getTime();
    }

    if (this.filters[this.FROM_PARAM]) {
      params['creationDateFrom'] = this.filters[this.FROM_PARAM].getTime();
    }

    this.exportProcesses = [];
    this.subscribe(
      this.plycaService.query<any>(
        this.configuration.EXPORTPROCESS_SERVICE_URL, params
      ).
        pipe(finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        })),
      (result: PaginationDTO<ExportProcessDTO>) => {
        if (result && result.content) {
          this.exportProcesses = result.content;
        }

      }

    );
  }

  download(exportProcess: ExportProcessDTO) {
    this.waitService.startWaiting();
    this.subscribe(this.plycaService.downloadExportProcess(exportProcess).pipe(finalize(() => {
      this.waitService.cancelWaiting();
    })));
  }

  viewDetail(exportProcess: ExportProcessDTO, duplicate = false) {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('Documents.export.process.title'),
      width: '70%',

      styleClass: 'searchStyle'
    };
    config['readonly'] = true;
    if (exportProcess) {
      config['id'] = exportProcess.identifier;
    }
    if (duplicate) {

      config['readonly'] = false;
    }


    config['duplicate'] = duplicate;
    const ref = this.dialogService.open(
      exportProcessEditionPanelComponent,
      config
    );

    this.subscribe(ref.onClose,
      result => {
        this.loadExportProcesses();
      });
  }


  duplicate(exportProcess: ExportProcessDTO) {
    this.confirmationService.confirm({
      message: this.translate.instant('ExportProcesses.copy.confirmation'),
      accept: () => {

        this.viewDetail(exportProcess, true);


      }
    });
  }
  run() {
    this.confirmationService.confirm({
      message: this.translate.instant('ExportProcesses.run.confirmation'),
      accept: () => {

      }
    });
  }

  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    config.fieldStyle = 'col-12 col-md-4';
    config.jsonField = name;
    if (name === this.FROM_PARAM) {
      config.type = 'DATE';
      config.description = 'Fecha desde:';
    } else if (name === this.TO_PARAM) {
      config.type = 'DATE';
      config.description = 'Fecha hasta:';
    } else if (name === this.USER_PARAM) {
      config.type = 'SEARCH';
      config.description = 'Usuario';
      config.idBuscador =
        'com.nexusit.framework.buscador.interfaz.BuscadorUsuarios';
      config.autoSearch = false;
    }
    return config;
  }




  getStatusColor(state: string): string {

    /*
     created,
    stopped,
    running,
    completed,
    error,

    */
    let ret = 'badge ';
    try {

      if (state === 'error') {
        ret += 'badge-danger';
      } else if (state === 'completed') {
        ret += 'badge-success';
      } else if (state === 'created') {
        ret += 'badge-secondary';
      } else if (state === 'running') {
        ret += 'badge-warning';
      } else {
        ret += 'badge-secondary';
      }
      return ret;
    } catch (ex) {
      return '';
    }
  }
}
